import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import Bone from '@lightspeed/cirrus-bone';
import Card, { CardSection } from '@lightspeed/cirrus-card';
import Select from '@lightspeed/cirrus-select';
import Text from '@lightspeed/cirrus-text';
import { Divider } from '@lightspeed/flame/Divider';
import map from 'lodash/map';
import get from 'lodash/get';

const Skeleton = () => (
  <Card>
    <CardSection noSpacing>
      <div className="cr-p-2 cr-width-full">
        <Bone height="0.8rem" />
      </div>
      <Divider />
      <div className="cr-p-2 cr-width-full">
        <Bone height="0.8rem" />
      </div>
      <Divider />
      <div className="cr-p-2 cr-width-full">
        <Bone height="0.8rem" />
      </div>
      <Divider />
      <div className="cr-p-2 cr-width-full">
        <Bone height="0.8rem" />
      </div>
      <Divider />
      <div className="cr-p-2 cr-width-full">
        <Bone height="0.8rem" />
      </div>
    </CardSection>
  </Card>
);

class PaymentTypeMapping extends Component {
  constructor(props) {
    super(props);

    this.renderMapping = this.renderMapping.bind(this);
  }

  renderMapping(mapping) {
    const { paymentTypes } = this.props;
    const paymentTypeOptions = paymentTypes.map(paymentType => (
      <option
        key={`${get(mapping, 'name')}_${get(paymentType, 'name')}`}
        value={get(paymentType, 'paymentTypeID')}
      >
        {get(paymentType, 'name')}
      </option>
    ));

    return (
      <div className="cr-flex cr-items-center cr-pl-3 cr-pr-3 cr-pt-1 cr-pb-1">
        <div className="cr-flex cr-width-full cr-width-4-12-lg">
          <Text bodySmall dimmed bold>
            {get(mapping, 'label')}
          </Text>
        </div>
        <div className="cr-flex cr-width-full cr-width-4-12-lg">
          <Field
            name={`cardMapping-${get(mapping, 'cardSchemeID')}`}
            render={({ field }) => <Select {...field}>{paymentTypeOptions}</Select>}
          />
        </div>
      </div>
    );
  }

  render() {
    const { cardMappings, isLoading } = this.props;
    return isLoading ? (
      <Skeleton />
    ) : (
      <Card>
        <CardSection noSpacing>
          {map(cardMappings, (cardMapping, index) => (
            <Fragment key={`card-mapping-${index}`}>
              {this.renderMapping(cardMapping)}
              {index < cardMappings.length - 1 && <Divider />}
            </Fragment>
          ))}
        </CardSection>
      </Card>
    );
  }
}

PaymentTypeMapping.propTypes = {
  paymentTypes: PropTypes.arrayOf(PropTypes.object),
  cardMappings: PropTypes.arrayOf(
    PropTypes.shape({
      cardSchemeID: PropTypes.string,
      paymentTypeID: PropTypes.string,
    })
  ),
  isLoading: PropTypes.bool,
};

PaymentTypeMapping.defaultProps = {
  paymentTypes: [],
  cardMappings: [],
  isLoading: true,
};

export default PaymentTypeMapping;
